import { GenericService } from '@/services/api/generic.service';
import { InadequateReason } from '@/models';

export class InadequateReasonService extends GenericService<InadequateReason> {
  endpoint = 'v1/inadequate-reasons';
}
